// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1PN-d","title":"Images45_title__2-1N3","images":"Images45_images__7uDZy"};